module.exports = __webpack_public_path__ + "img/材料力学1_3.96bc7264.jpg";